import ApiService from "@/common/api.service";

const PATH = "field-tag-types";

export const GET_FIELD_TAG_TYPES = "getFieldTagTypes";

const actions = {
  [GET_FIELD_TAG_TYPES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },
};

export default {
  actions,
};
